// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AccessSystemPage from './components/AccessSystemPage';
import ApiTester from './components/ApiTester';
import Dashboard from './pages/DashboardPage';
import StrategyDocsPage from './features/docs/StrategyDocsPage';
import { UserProvider } from './contexts/UserContext';  // Import the UserProvider
import { ThemeProviderWithMode } from './contexts/ThemeContext';
import { DashboardViewProvider } from './contexts/DashboardViewContext';

function App() {
  return (
      <UserProvider>
        <ThemeProviderWithMode>
          <DashboardViewProvider>
            <Router>
                <div>
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<HomePage />} exact />
                        <Route path="/access" element={<AccessSystemPage />} />
                        <Route path="/api-tester" element={<ApiTester />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/docs" element={<StrategyDocsPage />} />
                        <Route path="/docs/:docId" element={<StrategyDocsPage />} />
                    </Routes>
                    <div>
                      <br />
                      <Footer />
                    </div>
                </div>
            </Router>
          </DashboardViewProvider>
        </ThemeProviderWithMode>
      </UserProvider>
  );
}

export default App;
